import { fragmentUserBasic, fragmentMessageFull, serializeMessageFull } from './serializers';
import {
  gql,
  sendAPIRequest,
  simplifyGraphQLJSON,
  insertGraphQLFragments,
} from './GraphQLClient';


export async function getAnalyticsRating(params) {
  const { companyId, startDate, endDate, operatorIds } = params;
  const query = insertGraphQLFragments(gql`
    query ($companyId: Uuid!, $startDate: Date!, $endDate: Date!, $operatorIds: [ID!]) {
      analyticsEmployeesRating(companyId: $companyId, startDate: $startDate, endDate: $endDate, employeeIds: $operatorIds) {
        employees {
          id
          hasWorkingTime
          assignedCasesCount
          assignedRoomsCount
          selfAssignedCasesCount
          selfAssignedRoomsCount
          overdueCasesCount
          overdueRoomsCount
          manualSwitchOffCount
          manualSwitchOffDuration
          messagesCount
          avgResponseTime
          avgReactionTime
          avgCaseCloseTime
          overdueSwitchOffCount
          overdueSwitchOffDuration
          employee {
            ...fragmentUserBasic
          }
        }
        summary {
          assignedCasesCount
          assignedRoomsCount
          selfAssignedCasesCount
          selfAssignedRoomsCount
          overdueCasesCount
          overdueRoomsCount
          manualSwitchOffCount
          manualSwitchOffDuration
          messagesCount
          avgResponseTime
          avgReactionTime
          avgCaseCloseTime
          overdueSwitchOffCount
          overdueSwitchOffDuration
        }
      }
    }
  `, { fragmentUserBasic });

  const variables = {
    companyId,
    operatorIds,
    startDate,
    endDate,
  };
  return sendAPIRequest(query, variables);
}


export function getManualSwitchOffRecords(params){
  const {
    companyId,
    operatorId,
    periodFrom,
    periodTo,
    limit,
    afterCursor,
  } = params || {};

  const query = gql`
    query ($companyId: Uuid!, $operatorId: ID, $periodFrom: Date!, $periodTo: Date!, $changedBy: SwitchChangedBy, $toStatus: Boolean, $limit: Int!, $afterCursor: String) {
      analyticsSwitchChanges(companyId: $companyId, employeeId: $operatorId, startDate: $periodFrom, endDate: $periodTo, changedBy: $changedBy, toStatus: $toStatus, first: $limit, after: $afterCursor){
        edges {
          cursor
          node {
            id
            timestamp
            tillTimestamp
            status
            changedBy
            reasonType { id title }
            reasonText
          }
        }
      }
    }
  `;
  const variables = {
    companyId,
    operatorId,
    periodFrom,
    periodTo,
    changedBy: 'MANUAL',
    toStatus: false,
    limit: limit || 20,
    afterCursor: afterCursor || null,
  };
  return sendAPIRequest(query, variables).then(records => {
    return simplifyGraphQLJSON(records);
  });
}


export async function getAnalyticsOperatorMessages(params) {
  const {
    companyId,
    operatorId,
    afterCursor,
    limit,
  } = params || {};

  const query = insertGraphQLFragments(gql`
    query ($companyId: Uuid!, $operatorId: ID!, $limit: Int!, $afterCursor: String) {
      analyticsMessagesByEmployee(companyId: $companyId, employeeId: $operatorId, first: $limit, after: $afterCursor) {
        edges {
          cursor
          node {
            ...fragmentMessageFull
          }
        }
      }
    }
  `, { fragmentMessageFull });

  const variables = {
    companyId,
    operatorId,
    afterCursor,
    limit,
  };

  return sendAPIRequest(query, variables).then(messages => {
    return simplifyGraphQLJSON(messages).map(serializeMessageFull);
  });
}
